import getEditorServiceOverride from '@codingame/monaco-vscode-editor-service-override';
import getKeybindingsServiceOverride from '@codingame/monaco-vscode-keybindings-service-override';
import { LanguageClientConfig } from 'monaco-editor-wrapper';
import { useOpenEditorStub } from 'monaco-editor-wrapper/vscode/services';
import { useWorkerFactory } from 'monaco-editor-wrapper/workerFactory';
import { MonacoEditorLanguageClientWrapper, UserConfig } from 'monaco-editor-wrapper';
import monarchSyntax from "../syntaxes/while-star.monarch.js";

export const defineUserServices = () => {
    return {
        userServices: {
            ...getEditorServiceOverride(useOpenEditorStub),
            ...getKeybindingsServiceOverride()
        },
        debugLogging: true
    }
};

export const configureMonacoWorkers = () => {
    // override the worker factory with your own direct definition
    useWorkerFactory({
        ignoreMapping: true,
        workerLoaders: {
            editorWorkerService: () => new Worker(new URL('./wstar-server-workers.js',  window.location.href), { type: 'module' })
        }
    });
};

export const configureWorker = (): LanguageClientConfig => {
    // vite does not extract the worker properly if it is URL is a variable
    const lsWorker = new Worker(new URL('./wstar-server-workers.js',  window.location.href), {
        type: 'module',
        name: 'WhileStar Language Server'
    });

    return {
        options: {
            $type: 'WorkerDirect',
            worker: lsWorker
        }
    }
};


export const setupConfigClassic = (): UserConfig => {
    return {
        wrapperConfig: {
            serviceConfig: defineUserServices(),
            editorAppConfig: {
                $type: 'classic',
                languageId: 'while-star',
                code: (<HTMLTextAreaElement>document.getElementById('code'))!.value,
                useDiffEditor: false,
                languageExtensionConfig: { id: 'langium' },
                languageDef: monarchSyntax,
                editorOptions: {
                    minimap: { enabled: false },                    
                    'semanticHighlighting.enabled': true,
                    //theme: 'vs-light'
                }
            }
        },
        languageClientConfig: configureWorker()
    };
};


export const wrapper = new MonacoEditorLanguageClientWrapper();

declare global {
    interface Window {
        monacoWrapper:any;
    }
}

window.monacoWrapper = wrapper;

export const executeClassic = async (htmlElement: HTMLElement) => {
    const userConfig = setupConfigClassic();
    await wrapper.initAndStart(userConfig, htmlElement);
};

configureMonacoWorkers();
// keep a reference to a promise for when the editor is finished starting, we'll use this to setup the canvas on load
export const startingPromise = executeClassic(document.getElementById('monaco-editor-root')!);

